// extracted by mini-css-extract-plugin
export var priceNow = "SectionCta-module--priceNow--df07b";
export var pricePreviously = "SectionCta-module--pricePreviously--4efe8";
export var section = "SectionCta-module--section--22cef";